import {ColumnsType} from "antd/es/table";
import {message, Space, Tag} from "antd";
import {getToken, SendCodeReq, SendCodeResp} from "../../util/account";
import {getWindflowServerBaseUrl} from "../api";

export type ExchangeCodeProductCustomConfig = {
    lot_balance: number;
    fengling_balance: number;
};

export type ExchangeCode = {
    id: string;
    exchange_code: string;
    consume_channels: string;
    remark: string;
    product_purchase_item: string;
    product_amount: number;
    valid: boolean;
    used_count: number;
    product_custom_config: ExchangeCodeProductCustomConfig;
    exchange_success_hint: string;
    exchange_limit: number;
    created_at: string;
    updated_at: string;
};

export const emptyExchangeCode: ExchangeCode = {
    id: "",
    exchange_code: "",
    consume_channels: "",
    remark: "",
    product_purchase_item: "",
    product_amount: 0,
    valid: false,
    used_count: 0,
    product_custom_config: { lot_balance: 0, fengling_balance: 0 },
    exchange_success_hint: "",
    exchange_limit: 0,
    created_at: "",
    updated_at: "",
};

export type ExchangeCodeConsumeChannel = "AndroidApp,IOSApp,WechatMini" | "AndroidApp" | "IOSApp" | "WechatMini"

export const allExchangeCodeConsumeChannelList: ExchangeCodeConsumeChannel[] = ["AndroidApp,IOSApp,WechatMini", "AndroidApp", "IOSApp", "WechatMini"]

export function getExchangeCodeConsumeChannelDesc(type: ExchangeCodeConsumeChannel): string {
    if (type == "AndroidApp,IOSApp,WechatMini") return "全平台通用"
    if (type == "AndroidApp") return "安卓APP"
    if (type == "IOSApp") return "iOS APP"
    if (type == "WechatMini") return "微信小程序"
    return ""
}

export function getExchangeCodeConsumeChannelsDesc(consumeChannels: string): string {
    let cs = consumeChannels.split(',');
    let res = '';
    for (let i = 0; i < cs.length; i++) {
        res += getExchangeCodeConsumeChannelDesc(cs[i] as ExchangeCodeConsumeChannel) + ','
    }
    return res == '' ? res : res.substring(0, res.length - 1)
}

export type ProductPurchaseItem =
    "OneLot"
    | "FiveLot"
    | "TenLot"
    | "FenglingLevelInvitation"
    | "FenglingLevelOne"
    | "FenglingLevelOneMiddle"
    | "FenglingLevelTwo"
    | "MembershipMonthly"
    | "MembershipQuarterly"
    | "MembershipYearly"
    | "CustomExchangeCode"

export const allProductPurchaseItemList: ProductPurchaseItem[] = [
    "OneLot", "FiveLot", "TenLot", "FenglingLevelInvitation", "FenglingLevelOne", "FenglingLevelOneMiddle", "FenglingLevelTwo", "MembershipMonthly",
    "MembershipQuarterly", "MembershipYearly", "CustomExchangeCode"]

export function getProductPurchaseItemDesc(type: ProductPurchaseItem): string {
    if (type == "OneLot") return "一次抽签"
    if (type == "FiveLot") return "五次抽签"
    if (type == "TenLot") return "十次抽签"
    if (type == "FenglingLevelInvitation") return "80风翎"
    if (type == "FenglingLevelOne") return "880风翎"
    if (type == "FenglingLevelOneMiddle") return "1880风翎"
    if (type == "FenglingLevelTwo") return "6880风翎"
    if (type == "MembershipMonthly") return "月度会员"
    if (type == "MembershipQuarterly") return "季度会员"
    if (type == "MembershipYearly") return "年度会员"
    if (type == "CustomExchangeCode") return "自定义兑换码"
    return ""
}

export function ExchangeCodeColumn(
    detailFunc: (id: string) => void
): ColumnsType<ExchangeCode> {
    return [
        {
            title: "Id",
            dataIndex: "id",
            key: "id",
            width: 100,
            render: (_, record) => (
                record.id.toString()
            )
        },
        {
            title: "兑换码",
            dataIndex: "exchange_code",
            key: "exchange_code",
            width: 100
        },
        {
            title: "可用渠道",
            dataIndex: "consume_channels",
            key: "consume_channels",
            width: 120,
            render: (_, record) => (
                getExchangeCodeConsumeChannelsDesc(record.consume_channels)
            )
        },
        {
            title: "备注",
            dataIndex: "remark",
            key: "remark",
            width: 140
        },
        {
            title: "兑换单品",
            dataIndex: "product_purchase_item",
            key: "product_purchase_item",
            width: 120,
            render: (_, record) => (
                getProductPurchaseItemDesc(record.product_purchase_item as ProductPurchaseItem)
            )
        },
        {
            title: "兑换数量",
            dataIndex: "product_amount",
            key: "product_amount",
            width: 60
        },
        {
            title: "是否生效中",
            dataIndex: "valid",
            key: "valid",
            width: 120,
            render: (_, record) => (
                <Tag color={record.valid ? "success" : "magenta"}>
                    {record.valid ? "生效中" : "已失效"}
                </Tag>
            )
        },
        {
            title: "使用次数",
            dataIndex: "used_count",
            key: "used_count",
            width: 80
        },
        {
            title: "兑换限制",
            dataIndex: "exchange_limit",
            key: "exchange_limit",
            width: 80
        },
        {
            title: "成功提示",
            dataIndex: "exchange_success_hint",
            key: "exchange_success_hint",
            width: 120
        },
        {
            title: '操作',
            dataIndex: '',
            key: 'x',
            render: (_, record) => (
                <Space size="middle">
                    <a onClick={() => {
                        detailFunc(record.id)
                    }}>查看详情</a>
                </Space>
            ),
        },
    ]
}

export type ExchangeCodePaginationData = {
    total: number
    list: ExchangeCode[]
}

export type ExchangeCodePaginationResp = {
    code: number
    msg: string
    data: ExchangeCodePaginationData
}

export type ExchangeCodeListResp = {
    code: number
    msg: string
    data: ExchangeCode[]
}

export type ExchangeCodeResp = {
    code: number
    msg: string
    data: ExchangeCode
}

export type ExchangeCodeOpResp = {
    code: number
    msg: string
    data: string
}

export type QueryExchangeCodeByPageReq = {
    exchange_code: string;
    consume_channel: string;
    product_purchase_item: string;
    remark: string;
    page_num: number;
    page_size: number;
};

export const emptyQueryExchangeCodeByPageReq: QueryExchangeCodeByPageReq = {
    exchange_code: "",
    consume_channel: "",
    product_purchase_item: "",
    remark: "",
    page_num: 0,
    page_size: 0,
};

export function queryExchangeCodeByPage(req: QueryExchangeCodeByPageReq, callback: (success: boolean, resp?: ExchangeCodePaginationResp) => void) {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        }
    };

    fetch(getWindflowServerBaseUrl() + "/order/queryExchangeCodeByPage" + "?page_num=" + req.page_num + "&page_size="
        + req.page_size + "&exchange_code=" + req.exchange_code + "&consume_channel=" + req.consume_channel
        + "&remark=" + req.remark, options)
        .then(response => response.json())
        .then(res => {
            try {
                let resp = res as ExchangeCodePaginationResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
}


export type AddOrUpdateExchangeCodeReq = {
    exchange_code: string;
    consume_channels: string;
    remark: string;
    product_purchase_item: string;
    product_amount: number;
    valid: boolean;
    product_custom_config: ExchangeCodeProductCustomConfig;
    exchange_success_hint: string;
    exchange_limit: number;
};

export const emptyAddOrUpdateExchangeCodeReq: AddOrUpdateExchangeCodeReq = {
    exchange_code: "",
    consume_channels: "",
    remark: "",
    product_purchase_item: "",
    product_amount: 0,
    valid: false,
    product_custom_config: { lot_balance: 0, fengling_balance: 0 },
    exchange_success_hint: "",
    exchange_limit: 0,
};

export function addOrUpdateExchangeCode(req: AddOrUpdateExchangeCodeReq, callback: (success: boolean, resp?: ExchangeCodeOpResp) => void) {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(req),
    };

    fetch(getWindflowServerBaseUrl() + "/order/addOrUpdateExchangeCode", options)
        .then(response => response.json())
        .then(res => {
            try {
                let resp = res as SendCodeResp;
                callback(resp.code === 200, resp);
            } catch (e) {
                callback(false, undefined);
            }
        })
}